import {DestinationModel} from '@/Pages/Admin/Modules/ManagePackage/model/Master/DestinationModel';
import {TourTypeModel} from '@/Pages/Admin/Modules/ManagePackage/model/Master/TourTypeModel';
import {DifficultyLevelModel} from '@/Pages/Admin/Modules/ManagePackage/model/Master/DifficultyLevelModel';
import {PricingBasisModel} from '@/Pages/Admin/Modules/ManagePackage/model/Master/PricingBasisModel';

export class TrekModel {
    public id: number;
    public title: string;
    public destinationId: number;
    public teaser_title: string;
    public tourTypeId: number;
    public difficultyLevelId: number;
    public description: string;
    public altitude_in_meter: number;
    public altitude_in_feet: number;
    public basePrice: number;
    public pricingBasisId: number;
    public bookingsCount: number;
    public preBookingsCount: number;
    public base_price: number;
    public duration: string;
    public ageRange: string;
    public peopleRange: string;
    public destination: DestinationModel = new DestinationModel({});
    public tour_type: TourTypeModel = new TourTypeModel({});
    public difficulty_level: DifficultyLevelModel = new DifficultyLevelModel({});
    public pricing_basis: PricingBasisModel = new PricingBasisModel({});
    public cancellation_info: string;
    public extra_info: string;

    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.title = obj.title ? obj.title : '';
        this.destinationId = obj.destinationId ? obj.destinationId : 0;
        this.teaser_title = obj.teaser_title ? obj.teaser_title : '';
        this.tourTypeId = obj.tourTypeId ? obj.tourTypeId : 0;
        this.difficultyLevelId = obj.difficultyLevelId ? obj.difficultyLevelId : 0;
        this.description = obj.description ? obj.description : '';
        this.altitude_in_meter = obj.altitude_in_meter ? obj.altitude_in_meter : 0;
        this.altitude_in_feet = obj.altitude_in_feet ? obj.altitude_in_feet : 0;
        this.basePrice = obj.basePrice ? obj.basePrice : 0;
        this.pricingBasisId = obj.pricingBasisId ? obj.pricingBasisId : 0;
        this.bookingsCount = obj.bookingsCount ? obj.bookingsCount : 0;
        this.preBookingsCount = obj.preBookingsCount ? obj.preBookingsCount : 0;
        this.duration = obj.duration ? obj.duration : '';
        this.ageRange = obj.ageRange ? obj.ageRange : '';
        this.peopleRange = obj.peopleRange ? obj.peopleRange : '';
        this.destination = obj.destination ? obj.destination : new DestinationModel({});
        this.tour_type = obj.tour_type ? obj.tour_type : new TourTypeModel({});
        this.difficulty_level = obj.difficulty_level
            ? obj.difficulty_level
            : new DifficultyLevelModel({});
        this.pricing_basis = obj.pricing_basis
            ? obj.pricing_basis
            : new PricingBasisModel({});
        this.base_price = obj.base_price ? obj.base_price : 0;
        this.cancellation_info = obj.cancellation_info ? obj.cancellation_info : '';
        this.extra_info = obj.extra_info ? obj.extra_info : '';
    }
}
